import { render, staticRenderFns } from "./BoardTestRecord.vue?vue&type=template&id=5fbd7ac0&"
import script from "./BoardTestRecord.vue?vue&type=script&lang=js&"
export * from "./BoardTestRecord.vue?vue&type=script&lang=js&"
import style0 from "./BoardTestRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports